import { render, staticRenderFns } from "./religionform.vue?vue&type=template&id=42027590&"
import script from "./religionform.vue?vue&type=script&lang=js&"
export * from "./religionform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports